// @flow
import type { ErrorType } from '../../types';

export function setError(error: ErrorType) {
  return {
    type: 'SET_ERROR',
    error
  };
}

export function discardError() {
  return {
    type: 'DISCARD_ERROR'
  };
}
